import type { Swiper as SwiperType } from 'swiper';
import { useState } from 'react';
import SEO from '../components/SEO/SEO';
import MobileNav from '../components/Navigations/mobileNav';
import Nav from '../components/Navigations/desktopNav';
import PolicyContent from '../layout/client-side/policy';

const Policy = () => {
  const [swiper] = useState<SwiperType | null>(null);

  return (
    <>
      <SEO
        title="AirSolutions Belgium - Uw partner voor airconditioning en koeltechniek"
        description="Ontdek AirSolutions Belgium, uw betrouwbare partner voor airconditioning en koeltechniek. Wij bieden op maat gemaakte oplossingen voor residentiële en commerciële toepassingen."
        keywords="AirSolutions, airconditioning, koeltechniek, HVAC, residentieel, commercieel"
        canonical="/voorwaarden"
      />
      <MobileNav />
      <Nav swiper={swiper} />
      <PolicyContent />
    </>
  );
};

export default Policy;
